export const SET_ADDRESS = 'SET_ADDRESS';

export const setAddress = (data) => ({
  type: SET_ADDRESS,
  data: data
});